import Slide from "./Slide.vue"

export default Slide